import { Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import * as fromSeriousSystem from '@serious-system';

@Component({
  selector: 'squadbox-conversation-cta',
  imports: [
    TranslateModule,
    fromSeriousSystem.ButtonDirective,
    fromSeriousSystem.UseIconDirective,
  ],
  template: `
    <div
      role="button"
      [attr.tabindex]="isDisabled() ? -1 : 0"
      class="
        w-full max-w-180 tablet-landscape:min-h-20
        flex flex-col tablet-landscape:flex-row items-center justify-between
        gap-4 tablet-landscape:gap-6
        p-6 tablet-landscape:pr-4 tablet-landscape:py-3
        mb-4 tablet-landscape:mb-0
        bg-neutral-100 rounded-lg
        border-dashed-neutral-8 bg-clip-padding
      "
      [class.cursor-pointer]="!isDisabled()"
      (click)="handleClick()"
      (keydown.enter)="handleClick()"
      (keydown.space)="handleClick(); $event.preventDefault()"
    >
      <div class="flex flex-col tablet-landscape:flex-row items-center gap-4">
        <svg
          [sdUseIcon]="mainIcon()"
          class="text-primary-300 size-5 shrink-0"
        />
        <div
          class="w-full flex flex-col text-center tablet-landscape:text-left gap-1.5 [&>span>strong]:font-semibold"
        >
          <span class="typo-p2" [innerHTML]="mainText()"></span>
          @if (subText()) {
            <span
              class="typo-p3 text-neutral-500"
              [innerHTML]="subText()"
            ></span>
          }
        </div>
      </div>
      <button
        class="gap-1!"
        sdButton
        variant="outline"
        color="neutral"
        size="sm"
        [disabled]="isDisabled()"
      >
        @let btnIcon = buttonIcon();
        @if (btnIcon) {
          <svg [sdUseIcon]="btnIcon"></svg>
        }
        <span class="whitespace-nowrap">{{ buttonText() }}</span>
      </button>
    </div>
  `,
})
export class ConversationCTAComponent {
  public readonly mainIcon = input.required<fromSeriousSystem.IconsType>();
  public readonly mainText = input.required<string>();
  public readonly subText = input<string>();
  public readonly buttonIcon = input<fromSeriousSystem.IconsType>();
  public readonly buttonText = input.required<string>();
  public readonly isDisabled = input.required<boolean>();

  public readonly clicked = output<void>();

  protected handleClick(): void {
    if (!this.isDisabled()) {
      this.clicked.emit();
    }
  }
}
